/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Common_TextInputs */

const en_common_text = /** @type {(inputs: Common_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Text`)
};

const es_common_text = /** @type {(inputs: Common_TextInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Texto`)
};

/**
* | output |
* | --- |
* | "Text" |
*
* @param {Common_TextInputs} inputs
* @param {{ locale?: "en" | "es" }} options
* @returns {LocalizedString}
*/
export const common_text = /** @type {((inputs?: Common_TextInputs, options?: { locale?: "en" | "es" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Common_TextInputs, { locale?: "en" | "es" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "es") return es_common_text(inputs)
	return en_common_text(inputs)
});